import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { TokenService } from './services/token.service';
import { EMPTY, catchError, switchMap, take, throwError } from 'rxjs';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

export const httpconfigInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) : Observable<HttpEvent<any>>=> {

  const tokenService = inject(TokenService);
  const router = inject(Router);

  tokenService.isAuthentication.subscribe({
    next:(value) =>{
      if(value){
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${tokenService.getToken()}`
          }
        });
      }      
    }
  })

  return next(req).pipe(
    catchError((e: HttpErrorResponse)=>{
        if(e.status === 401 ){
          tokenService.removeToken();
          router.navigate(['pub/login']);
        } 
        const error = e.error?.message || e.statusText;
        return throwError(() => error);
    })
  );
};
